import { createApp } from "vue";
import "./http";
import store from "./store"; // Vuex
import i18n from "./i18n"; // i18n

// карусель в CreateCampaign
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

//  https://vue-smart-table.netlify.app/
import SmartTable from "vuejs-smart-table";
// import 'vue-good-table-next/dist/vue-good-table-next.css';

// fullScreenLoading
// https://element-plus.org/
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

// prompt v-tippy
// https://vue-tippy.netlify.app/
// https://atomiks.github.io/tippyjs/
import VueTippy from "vue-tippy";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

import Campaigns from "./components/Campaign/Campaigns.vue";
import CampaignCreate from "./components/Campaign/CampaignCreate/CampaignCreate.vue";
import AdGroupCreate from "./components/AdGroup/AdGroupCreate/AdGroupCreate.vue";
// CampaignStatistic component removed

import Creatives from "./components/Creatives/Creatives.vue";
import CreativeCreate from "./components/Creatives/CreativeCreate.vue";
import CreativePreview from "./components/Creatives/CreativePreview.vue";
import RichMedia from "./components/Creatives/RichMedia.vue";
import AdGroupCreatives from "./components/AdGroup/AdGroupCreatives.vue";

import Users from "./components/Users.vue";

import Login from "./components/Login.vue";
import AppHeader from "./components/Appheader.vue";
import TechnicalRequirements from "./components/TechnicalRequirements.vue";
import Segments from "./components/Segments.vue";
import Reports from "./components/Reports/Reports.vue";
import DetailedStatistic from "./components/Campaign/DetailedStatistic.vue";

const app = createApp({});

// Регистрация компонентов
app.component("campaigns", Campaigns);
app.component("campaign-create", CampaignCreate);
app.component("adgroup-create", AdGroupCreate);
// campaign-statistic component registration removed

app.component("creatives", Creatives);
app.component("creative-create", CreativeCreate);
app.component("creative-preview", CreativePreview);
app.component("rich-media", RichMedia);
app.component("ad-group-creatives", AdGroupCreatives);

app.component("users", Users);

app.component("login", Login);
app.component("app-header", AppHeader);
app.component("technical-requirements", TechnicalRequirements);
app.component("segments", Segments);
app.component("reports", Reports);
app.component("detailed-statistic", DetailedStatistic);

app.component("Carousel", Carousel);
app.component("Slide", Slide);

app.use(store);
app.use(i18n);
app.use(ElementPlus);
app.use(VueTippy);
app.use(SmartTable);

app.mount("#app");
